export default function Sentiment1() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 27.15C21.7667 27.15 19.7417 27.775 17.925 29.025C16.1083 30.275 14.7667 31.9333 13.9 34H34.1C33.2667 31.9333 31.9333 30.275 30.1 29.025C28.2667 27.775 26.2333 27.15 24 27.15ZM24 44C21.2667 44 18.6833 43.475 16.25 42.425C13.8167 41.375 11.6917 39.9417 9.875 38.125C8.05833 36.3083 6.625 34.1833 5.575 31.75C4.525 29.3167 4 26.7333 4 24C4 21.2333 4.525 18.6333 5.575 16.2C6.625 13.7667 8.05833 11.65 9.875 9.85C11.6917 8.05 13.8167 6.625 16.25 5.575C18.6833 4.525 21.2667 4 24 4C26.7667 4 29.3667 4.525 31.8 5.575C34.2333 6.625 36.35 8.05 38.15 9.85C39.95 11.65 41.375 13.7667 42.425 16.2C43.475 18.6333 44 21.2333 44 24C44 26.7333 43.475 29.3167 42.425 31.75C41.375 34.1833 39.95 36.3083 38.15 38.125C36.35 39.9417 34.2333 41.375 31.8 42.425C29.3667 43.475 26.7667 44 24 44ZM24 41C28.7333 41 32.75 39.3417 36.05 36.025C39.35 32.7083 41 28.7 41 24C41 19.2667 39.35 15.25 36.05 11.95C32.75 8.65 28.7333 7 24 7C19.3 7 15.2917 8.65 11.975 11.95C8.65833 15.25 7 19.2667 7 24C7 28.7 8.65833 32.7083 11.975 36.025C15.2917 39.3417 19.3 41 24 41Z"
        fill="currentColor"
      />
      <path
        d="M32.9498 16.5L30.6998 18.75L28.4498 16.5L26.6498 18.3L30.6998 22.35L34.7498 18.3L32.9498 16.5ZM19.5998 16.5L17.3498 18.75L15.0998 16.5L13.2998 18.3L17.3498 22.35L21.3998 18.3L19.5998 16.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
